<template>
  <transition name="fade">
    <div v-show="statuses.length" class="order-filters-component">
      <v-btn-toggle
        :value="value"
        dense
        group
        mandatory
        @change="onChange"
      >
        <v-badge
          v-for="(status, i) in statuses"
          v-show="status.ruName"
          :key="i"
          bordered
          :color="getColor(status.filterParam)"
          :content="status.count || '0' "
          :disabled="disabled"
          overlap
          class="filter-badge"
          :class="{
            'filter-badge-all': status.filterParam === 'all',
            'filter-badge-hide-counter': isCounterHidden(status)
          }"
        >
          <v-btn
            :value="status.filterParam"
            class="button-filter font-weight-light text-normalize"
            :class="{'button-all': status.filterParam === 'all'}"
            color="#ffffff"
            :disabled="disabled"
            :ripple="false"
            depressed
          >
            {{ status.ruName }}
          </v-btn>
        </v-badge>
      </v-btn-toggle>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'OrderFilters',
    props: {
      statuses: {
        type: Array,
        default: () => [],
      },
      value: {
        type: String,
        default: null,
      },
      disabled: Boolean,
    },
    data () {
      return {
        colors: [
          { name: 'new', color: '#FF9100' },
          { name: 'readyForIssue', color: '#ABDB49' },
          { name: 'awaiting', color: '#F4B083' },
          { name: 'preparing', color: '#38B2B2' },
          { name: 'assembly', color: '#614EE2' },
          { name: 'inDelivery', color: '#1EBFE9' },
          { name: 'done', color: '#1EE984' },
          { name: 'preorder', color: '#C9C9C9' },
          { name: 'dovoz', color: '#4A4A4A' },
          { name: 'canceled', color: '#C9C9C9' },
          { name: 'confirmed', color: '#AAAAAA' },
          { name: 'aggregate', color: '#7A7A7A' },
          { name: 'lateness', color: '#E91E63' },
          { name: 'done', color: '' },
        ],
      }
    },
    methods: {
      onChange (value) {
        if (!value || value === this.value) {
          return
        }
        this.$emit('filterOrders', value)
      },
      getColor (value) {
        const item = this.colors.find(status => status.name.toLowerCase() === value.toLowerCase())
        return item ? item.color : '#FF9100'
      },
      isCounterHidden (status) {
        return status.count < 0
      },
    },
  }
</script>

<style lang="less" scoped>
  .order-filters-component {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    padding: 11px 15px 8px 15px;
    border-radius: 5px;
    background-color: @color-secondary;
    overflow-y: auto;

    // Мобильные экраны: статусы лентой со скроллом вбок, бейджи не растягиваются.
    .media-sm({
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;

      .v-btn-toggle {
        flex-wrap: nowrap;
      }

      .filter-badge {
        flex: 0 0 auto;
        flex-grow: 0;
      }
    });

    .filter-badge {
      margin-right: 15px;
      flex-grow: 1;

      &:last-child {
        margin-right: 0;
      }

      &::v-deep {
        .v-badge__wrapper {
          top: 5px;
          left: -5px;
          .v-badge__badge {
            font-size: 11px;
            height: 19px;
            min-width: 19px;

            &::after {
              border-color: @color-secondary;
            }

            .media-xl({
              font-size: 12px;
              height: 20px;
              min-width: 20px;
            });
          }
        }

      }

      &.filter-badge-all {
        &::v-deep {
          .v-badge__badge {
            background-color: #0033FF !important;
            &:after {
              color: #ffffff !important;
            }
          }
        }
      }

      &.filter-badge-hide-counter {
        &::v-deep {
          .v-badge__badge {
            opacity: 0;
            background-color: #0033FF !important;
            &:after {
              color: #ffffff !important;
            }
          }
        }
      }
    }

    .button-filter {
      height: 32px;
      font-size: 11px;
      line-height: 1.2;
      border-radius: 100px;
      //min-width: 110px;
      width: 100%;

      &.button-all {
        //background-color: #0033FF !important;
        //color: #ffffff;
      }

      .media-xl({
        height: 42px;
        font-size: 12px;
      });
    }
    ::v-deep {
      .v-item-group {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
      .v-item--active {
        background-color: #0033FF !important;
        color: #ffffff;
        &:before {
          display: none;
        }
      }
    }

    .media-xl({
      margin-top: 20px;
      padding: 11px 44px 8px 24px;

      .button-filter {
        height: 52px;
        font-size: 16px;
        line-height: 19px;
        border-radius: 100px;
        min-width: 110px;
        width: 100%;
      }
    });
  }
</style>
